import { BidsSortable } from "components/bids";
import { Transition } from "components/shared/column";
import { load, store } from "helpers/filtersStorage";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import policy from "policies";
import React from "react";
import { withRouter } from "react-router-dom";
import Filter from "./filter";
import List from "./list";

class DistributionBids extends BidsSortable {
    state = {
        items: [],
        filtersOpened: false,
        activeSort: {},
        showFullAddress: load("showDistributionBidsFullAddress", false),
    };

    renderCreateButton = () => {
        const { history } = this.props;
        const props = {
            className: "btn btn-brand btn-sm",
            onClick: () => history.push(paths.distributionBidsNew),
        };
        return <div {...props}>Создать заказ</div>;
    };

    toggleFilter = () => {
        this.setState({ filtersOpened: !this.state.filtersOpened });
    };

    toggleFullAddress = () => {
        store("showDistributionBidsFullAddress", !this.state.showFullAddress);
        this.setState({ showFullAddress: !this.state.showFullAddress });
    };

    renderHead = () => {
        const { roles } = this.props;
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">
                    {this.props.title}
                    {this.renderCounter()}
                </div>
                <div className="btn-toolbar">
                    {!policy("user", { user: { roles } }).isReadOnlyTruckingOrganizationUser() &&
                        this.renderCreateButton()}
                </div>
            </div>
        );
    };

    render() {
        const { listRoute, params, mergeParams, organizationTimezone, roles, organization, transition, enums } =
            this.props;
        const { customFilters } = params;
        const { items, activeSort, filtersOpened, showFullAddress } = this.state;
        const listProps = {
            activeSort,
            showFullAddress,
            sortData: this.sortData,
            checkedItems: items,
            showAllPointAddresses: customFilters.showAllPointAddresses,
            showOrganizationColumn: customFilters.showOrganizationColumn,
            showCostAwareValues: customFilters.showCostAwareValues,
        };

        const filterProps = {
            params,
            mergeParams,
            organizationTimezone,
            filtersOpened,
            showFullAddress,
            roles,
            enums,
            organization,
            filters: customFilters || {},
            toggleFilter: this.toggleFilter,
            toggleFullAddress: this.toggleFullAddress,
        };
        return (
            <Transition dir={transition ?? "full"} {...listRoute}>
                <div className="page-book__list book-list list">
                    {this.renderHead()}
                    <div className="container-fluid mt-1 mb-3">
                        <Filter {...filterProps} />
                    </div>
                    <List {...this.props} {...listProps} />
                </div>
            </Transition>
        );
    }
}

export default withRouter(tableContainer(DistributionBids, "distributionbids"));
